import { Component, OnInit } from '@angular/core';
import { EmopPublicWorkflowApprovalService } from '../../emop-public-workflow-approval.service';
import { EmopPublicWorkflowApprovalApiService } from '../../emop-public-workflow-approval-api.service';
import { EmopFormProClass } from '../../../../../app/class/EmopFormProClass/EmopFormProClass';

@Component({
  selector: 'app-emop-public-workflow-approval-object',
  templateUrl: './emop-public-workflow-approval-object.component.html',
  styleUrls: ['./emop-public-workflow-approval-object.component.scss']
})
export class EmopPublicWorkflowApprovalObjectComponent implements OnInit {
  EmopFormData = new EmopFormProClass([
    {
      alias: '流程名',
      key: 'workflowName',
      mode: 'str',
      value: '',
      disabled: true
    },
    {
      alias: '备注',
      key: 'comments',
      mode: 'str',
      value: '',
      disabled: true
    }
  ]);
  loading: boolean = true; // 当前模块是否加载中

  constructor(
    public EmopPublicWorkflowApprovalService: EmopPublicWorkflowApprovalService,
    private EmopPublicWorkflowApprovalApiService: EmopPublicWorkflowApprovalApiService
  ) { }

  ngOnInit(): void {
    this.EmopPublicWorkflowApprovalApiService.getApprovalObject(this.EmopPublicWorkflowApprovalService.processInstanceId).subscribe((rs) => {
      this.EmopFormData[0].value = rs.data.workflowName;
      this.EmopFormData[1].value = rs.data.remark;
      if (rs.data.businessObjects) {
        this.EmopPublicWorkflowApprovalService.approvalObjectTable.data = rs.data.businessObjects;
      }
      this.loading = false;
    });
  }
  openUrl(data) {
    if (this.EmopPublicWorkflowApprovalService.onApprovalTableClick) {
      this.EmopPublicWorkflowApprovalService.onApprovalTableClick(data);
    } else {
      data._url && open(data._url);
    }
  }
}
